<template>
  <Teleport to="body">
    <div
      v-if="visible"
      class="guidance-finish"
    >
      <div class="guidance-finish__backdrop" />
      <div class="guidance-finish__card">
        <div class="guidance-finish__header">
          <div class="guidance-finish__icon-ring">
            <i class="dx-icon-check" />
          </div>
          <h2 class="guidance-finish__title">
            {{ t("guidance.finishTitle") }}
          </h2>
        </div>
        <div class="guidance-finish__body">
          <p
            class="guidance-finish__text"
            v-html="t('guidance.finishDescription')"
          />
        </div>
        <div class="guidance-finish__actions">
          <DxButton
            :text="t('guidance.finishRetake')"
            type="normal"
            styling-mode="outlined"
            @click="emit('retake')"
          />
          <DxButton
            :text="t('guidance.finishStartWork')"
            type="default"
            styling-mode="contained"
            @click="emit('finish')"
          />
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import DxButton from "devextreme-vue/button";

interface Props {
  visible: boolean;
}

defineProps<Props>();

const emit = defineEmits<{
  finish: [];
  retake: [];
}>();

const { t } = useI18n();
</script>
